[
  {
    "id": "pTIH01xTfus",
    "title": "How to Use Teacher Mode in Robogebra",
    "tags": ["How to use", "Teacher Mode"]
  },
  {
    "id": "d76LhwW7M-8",
    "title": "Analytics in Robogebra",
    "tags": ["How to use", "Analytics"]
  },
  {
    "id": "3y4EC_QJxe0",
    "title": "Solution View in Robogebra",
    "tags": ["How to use", "Solutions"]
  },
  {
    "id": "_RTK14kwrYw",
    "title": "How Teachers Can Create Their Own Solutions in Robogebra",
    "tags": ["How to use", "Solutions"]
  },
  {
    "id": "7MQtM5W7oXE",
    "title": "How to Use Interactive Worksheets for Teaching in Robogebra",
    "tags": ["How to use", "Worksheets"]
  },
  {
    "id": "Wn2tM7h6AcA",
    "title": "How Teachers Can Lock and Unlock Solutions in Robogebra",
    "tags": ["How to use", "Solutions"]
  },
  {
    "id": "Msl3QZr0JV8",
    "title": "How to Use Edit and Explore Feature in Robogebra",
    "tags": ["How to use", "Edit & Explore"]
  }
]
